require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/fn/get-iterator.js
// module id = ../../../../core-js/library/fn/get-iterator.js
// module chunks = 7